import React from 'react';
import { connect } from 'react-redux';
import { Router } from 'react-router-dom';
import { Routes, history } from './routes';

import Error from './pages/commons/Error';
import Splash from './components/commons/Splash';
import Slider from './pages/commons/Slider';

import oauth from './context/oauth/actions'
import config from './config';
import { getTimeZone, getClientIp, getLatLng } from './libraries/utils';
import internalsActions from './context/internals/actions';

import { QueryClient, QueryClientProvider, useQuery } from 'react-query'
import { ToastContainer } from 'react-toastify';
import actions from './context/settings/actions';
import actionsUsers from './context/users/actions';
import { notify } from './libraries/notifications';

class App extends React.Component {
  constructor(props) {
    super(props);
    // El slider se inicializa desde localStorage de forma sincrónica para no "flashear" en
    // cada carga: si el usuario ya lo descartó (SLIDER_SCREEN=false), arranca oculto.
    const storedSlider = localStorage.getItem(config.SLIDER_SCREEN);
    this.state = {
      splash: true,
      slider: storedSlider ? JSON.parse(storedSlider) : true,
    }
    this.currentPathname =  null;
    this.currentSearch =  null;
    this.currentState =  null;
  }
  
  async componentDidMount() {
    console.log('STARTING_APP', process.env.NODE_ENV);
    await this.props.onOauth();
    await this.userToken();
    // El slider solo se evalúa la primera vez (si nunca se descartó). Si ya se descartó,
    // el valor se leyó del localStorage en el constructor y no reaparece. Se muestra según
    // el modo de la app (normal/evento), independiente del onboarding.
    const stored = localStorage.getItem(config.SLIDER_SCREEN);
    if (stored === null) {
      let appMode = "normal";
      if (this.props.auth?.user?.unique_id) {
        await this.get_event_setting();
        appMode = this.props.mode_app_settings?.item?.value || "normal";
      }
      
      const showForMode = config.SLIDER[appMode]?.SHOW ?? config.SLIDER.normal.SHOW;
      console.log("APPMODE===", {
        appMode,  event:this.props.mode_app_settings?.item?.value, showForMode
      })
      this.setState({ slider: showForMode });
    }

    // Configure history so the user can't do back in the browser
    history.listen((newLocation, action) => {
      // console.warn('HISTORY LISTEN', newLocation, action);
      // console.warn('CURRENT LOCATION', this.currentPathname, this.currentSearch, this.currentState);
      if (action === "PUSH") {
        if (
          newLocation.pathname !== this.currentPathname ||
          newLocation.search !== this.currentSearch
        ) {
          //let fromPathApp = this.currentPathname
          // Save new location
          this.currentPathname = newLocation.pathname;
          this.currentSearch = newLocation.search;
          this.currentState = newLocation.state;
          // Clone location object and push it to history
          history.push({
            pathname: newLocation.pathname,
            search: newLocation.search,
            state: {...newLocation.state, }, //fromPathApp
          });
        }
      } else {
        // Send user back if they try to navigate back
        history.go(1);
      }
    });
    // Get information about the device
    //this.getClientInfo();
  }

  userToken = async () => {
    await this.props.onGetToken();
}

  getClientInfo = async () => {
    // const geonames = Geonames({
    //   username: 'lavadoelex',
    //   lan: 'es',
    //   encoding: 'JSON'
    // });
    
    //const ip = await getClientIp();
//    //console.warn('CLIENT IP', ip);
//
    //await this.props.onGetClientIpInfo({ ip });
    //const { data } = this.props.internals;
    //console.log('INTERNALS', this.props.internals, data);
    //if (data && data.error) { 
    //  console.error('ERROR', this.t(data.error.message));
    //} else {
    //  console.warn('USER IP INFO', data && data.geoip);
    //}    
    //console.warn('TIME ZONE', getTimeZone(), data && data.geoip.timezone );

    //getLatLng((latlng) => {
    //  console.warn('LAT & LNG', latlng);
    //});

  }
  get_event_setting = async () => {
    await this.props.onGetEventSettings({
      "type": "sharyco_settings",
      "code": "app_event",
      "owner": this.props.auth.user.unique_id
    });
    const { mode_app_settings } = this.props;
    if (mode_app_settings.error) {
      notify(mode_app_settings.error.message);
    } else {
      this.setState({event_settings:mode_app_settings.item})
    }
  }

  render() {
    const { loading, error, granted } = this.props.oauth;
    if (loading || this.state.splash) { 
      setTimeout(() => {
        this.setState({ splash: false });
      }, 100);
      return (<Splash />);
    }
    // if (this.state.slider) {
    //   return (<Slider close={(slider) => this.setState({ slider }) } />);
    // }
    if (error) return ( 
      <Error title="API ERROR" headline="Access not granted!" button="Close"/>
    );

    if (granted && !this.state.splash) return ( 
      <Router history={history}>
        <Routes/>
      </Router>  
    );

    return (<Splash />);
  }
}

const mapStateToProps = state => {
  return {
    auth: state.users.auth,
    oauth: state.oauth,
    internals: state.internals,
    mode_app_settings: state.settings.appmode,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onOauth: () => dispatch(oauth.getFromToken()),
    onGetClientIpInfo: (params) => dispatch(internalsActions.getClientIpInfo(params)),
    onGetEventSettings:(params)=>dispatch(actions.getAllEvent(params)),
    onGetToken: () => dispatch(actionsUsers.getFromToken()),

  };
};

let AppComponent =  connect(
  mapStateToProps,
  mapDispatchToProps,
)(App);

const queryClient = new QueryClient()

export default function QueryWrapper() {
  return (
    <QueryClientProvider client={queryClient}>
      <AppComponent />
      <ToastContainer/>
    </QueryClientProvider>
  )
}